export const confirmPageTestId = "cdp-confirm-page";
